import React from 'react';
import { Link } from 'react-router-dom';
import './About.css';

const About = () => {
  return (
    <div className="about-page">
      <div className="about-hero">
        <h1>Our Story</h1>
      </div>

      <div className="about-content">
        <section className="about-section">
          <div className="about-text">
            <h2>Welcome to Epoxy Garden</h2>
            <p>
              Founded in 2024, Epoxy Garden was born from a passion for creating
              beautiful, high-quality children's clothing that captures the magic 
              of childhood. Our carefully curated collection combines timeless designs 
              with modern sensibilities, ensuring each piece is both beautiful and practical.
            </p>
          </div>
          <div className="about-image">
            <img src="https://framedliquor.com/cdn/shop/files/Lijst_33_x_43_4.png?v=1712220829&width=1646" alt="Our Store" />
          </div>
        </section>

        <section className="about-section reverse">
          <div className="about-text">
            <h2>Our Philosophy</h2>
            <p>
              We believe that children's clothing should be both beautiful and functional. 
              Every piece in our collection is thoughtfully designed with high-quality, 
              sustainable materials that are gentle on sensitive skin and stand up to 
              the adventures of childhood.
            </p>
          </div>
          <div className="about-image">
            <img src="https://framedliquor.com/cdn/shop/files/Lijst_33_x_43_4.png?v=1712220829&width=1646" alt="Our Philosophy" />
          </div>
        </section>

        <section className="values-section">
          <h2>Our Values</h2>
          <div className="values-grid">
            <div className="value-card">
              <h3>Quality</h3>
              <p>Premium materials and expert craftsmanship in every piece</p>
            </div>
            <div className="value-card">
              <h3>Sustainability</h3>
              <p>Eco-friendly practices and materials in all our products</p>
            </div>
            <div className="value-card">
              <h3>Community</h3>
              <p>Supporting families and creating lasting memories</p>
            </div>
          </div>
        </section>

        <section className="cta-section">
          <h2>Join Our Journey</h2>
          <p>Discover our latest collection and be part of our story.</p>
          <Link to="/shop" className="shop-button">Shop Now</Link>
        </section>
      </div>
    </div>
  );
};

export default About;
